// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3RQWg","footer":"Form_footer__WmyyM"};